import { t } from 'i18next';

import { type ScenarioWithElements, type Scenario } from './types';
import { type TranslationKey } from '../i18n/types';

/**
 * Generates a unique key for a scenario based on the scenario ID and user UID.
 * This helps in tracking whether a user has completed a specific scenario.
 */
export function generateScenarioKey(scenarioId: string, userUID: string): string {
  return `${scenarioId}-${userUID}`;
}

export function translateScenarios(scenarios: Scenario<TranslationKey>[]): Scenario<string>[] {
  return scenarios.map(scenario => ({
    ...scenario,
    steps: scenario.steps.map(step => ({
      ...step,
      popover: {
        ...step.popover,
        title: t(step.popover.title),
        description: t(step.popover.description),
      },
    })),
  }));
}

export function getElementsFromScenarios(scenarios: Scenario[], userUniqueId: string): ScenarioWithElements[] {
  const filteredScenarios = scenarios.filter(scenario => {
    const scenarioKey = generateScenarioKey(scenario.id, userUniqueId);
    const isScenarioSeen = JSON.parse(localStorage.getItem(scenarioKey) ?? 'false');

    return !isScenarioSeen;
  });

  return filteredScenarios.map(scenario => {
    return {
      id: scenario.id,
      elements: scenario.steps.map(step => step.element),
    };
  });
}
